<template>
	<div v-if="can('roles.index')">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<router-link to="/administration" tag="li" class="breadcrumb-item"><a href="">{{i18n('Administration')}}</a></router-link>
				<router-link to="/roles" tag="li" class="breadcrumb-item"><a href="">{{i18n("Role users")}}</a></router-link>
			</ol>
		</nav>

        <div class="base_box_hdr">
            <div class="base_box_ttl">
                <div class="row">
                    <div class="col-sm-12">
                        <h1 class="title">{{i18n("Role users")}}</h1>
                    </div>
                </div>
            </div>
            <div class="base_box_cnt">
                <div class="row">
                    <div class="col-md-8 col-sm-12 col-12">
                        <div class="button-group" v-if="can('roles.create')">
                            <router-link to="/roles/form" class="btn base_btn solid_blue waves-effect waves-light">
                                {{i18n('Create')}}
                            </router-link>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12 col-12">
						<div class="base_input_bx">
							<form action="" class="search" v-on:submit.prevent>
								<div class="base_input_bx">
									<input type="text" class="form-control base_input" :placeholder="i18n('Filter')" v-model="search" @keyup="filter">
									<i class="mdi mdi-magnify"></i>
								</div>
							</form>
						</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="base_box_main">
			<div class="base_box">
				<div class="base_box_cnt">
					<div class="responsive-table">
						<table class="table table-striped table-hover mb-0">
							<thead>
							<tr>
								<th scope="col">{{i18n("Roles")}}</th>
								<th scope="col">{{i18n("Number of permissions")}}</th>
								<th scope="col">{{i18n("Count users")}}</th>
								<th class="last-th" scope="col"></th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="(item, key) in filteredRoles">
								<td>{{item.name}}</td>
								<td>{{item.permissions_count}}</td>
								<td>{{item.users_count}}</td>
								<td class="text-center">
									<button type="button" class="btn-icon" v-if="can('roles.edit')" @click="Update(item.id)">
										<i class="mdi mdi-pencil text-primary"></i>
									</button>
									<button type="button" class="btn-icon" v-if="can('roles.delete')" @click="Delete(item.id)">
										<i class="mdi mdi-minus-circle text-danger"></i>
									</button>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FormService from "../../services/FormService";
	import FormInput from '../../components/FormInput';


	export default {
		components: {
			FormInput,
		},
		data(){
			return {
				form: new FormService({
					name: null,
					price: null,
					status: null,
					is_required: false,
				}),
				search: '',

				roles: [],
				filteredRoles: [],
				modelStatus: [
					{
						"code": 5,
						"name": "inactive",
					},
					{
						"code": 10,
						"name": "active",
					},
				],
				status: 0,
			}
		},
		methods: {
			filter() {
				this.filteredRoles = this.roles.filter(role => role.name.toLowerCase().includes(this.search));
			},
			Update(id) {
                this.$router.push('/roles/form/' + id);
			},
			Delete(id) {
				if (confirm(this.i18n('You are about to delete the record! \nAre you sure?'))) {
					this.$api.delete('access-control.roles.delete', id)
						.then(res => {
							if (!res.errors) {
								this.GetRoles();
								this.$store.commit('successNotify')();
							}
						});
				}
			},
			GetRoles() {
				this.$api.get('access-control.roles.index')
					.then(res => {
						this.roles = res.data;
						this.filter();
					});
			},
		},
		mounted() {
			this.GetRoles();
			$('#exampleModal').on('hidden.bs.modal', (e) => {
				this.form.reset();
				this.form.is_required = false;
			})
		}
	}
</script>


<style></style>
